import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import axios from "axios";
import configData from "../../../config.json";

const ragaImage = "/GarbhaSanskar/ragaimg.png";

const getRagaTitle = (name = "") => {
  const title = name.replace(/\.mp3$/i, "").replace(/\s+/g, " ").trim();

  if (title.toLowerCase() === "raga1") {
    return "Pregnancy Raga 1";
  }

  return title.replace(/([a-z])([A-Z])/g, "$1 $2");
};

const getAudioUrl = (url = "") => {
  if (!url) {
    return "";
  }

  if (/^https?:\/\//i.test(url)) {
    return url;
  }

  return `${configData.API_URL.replace(/\/$/, "")}${url}`;
};

function PregnancyRaga({ setExpand, setSelected }) {
  const [testinfo, settestinfo] = useState(false);
  const [testdata, settestdata] = useState(null);
  const [ragaList, setRagaList] = useState([]);
  const [isLoadingRagas, setIsLoadingRagas] = useState(true);
  const [ragaError, setRagaError] = useState("");

  const handletestinfo = (r) => {
    settestinfo(true);
    settestdata(r);
  };
  function backtotestlist() {
    settestinfo(false);
    settestdata(null);
  }

  useEffect(() => {
    const getPregnancyRaga = async () => {
      try {
        setIsLoadingRagas(true);
        setRagaError("");

        const response = await axios.get(
          `${configData.SERVER_API_URL}/common/get_pregnancy_raga`,
        );

        if (response.data.success && Array.isArray(response.data.files)) {
          setRagaList(
            response.data.files.map((file) => ({
              testname: getRagaTitle(file.name),
              img: ragaImage,
              img2: getAudioUrl(file.url),
            })),
          );
        } else {
          setRagaList([]);
          setRagaError("Pregnancy Raga audio is not available right now.");
        }
      } catch (error) {
        console.error("Error fetching pregnancy raga:", error);
        setRagaList([]);
        setRagaError("Unable to load Pregnancy Raga audio. Please try again.");
      } finally {
        setIsLoadingRagas(false);
      }
    };

    getPregnancyRaga();
  }, []);

  const isTabScreen = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1023px)",
  });
  const isMobile = useMediaQuery({
    query: "(max-width: 767px)",
  });
  const back = {
    fontWeight: "600",
    fontSize: "12px",
    color: "#004AAD",
    cursor: "pointer",
    letterSpacing: "0.3px",
  };
  const heading = {
    color: "#F0588B",
    fontWeight: "600",
    fontSize: isMobile ? "20px" : isTabScreen ? "22px" : "24px",
    paddingTop: "10px",
    paddingBottom: "6px",
  };
  const innercol = {
    marginTop: isMobile ? "16px" : "24px",
    cursor: "pointer",
    paddingLeft: isMobile ? "6px" : "12px",
    paddingRight: isMobile ? "6px" : "12px",
  };
  const innerrow = {
    paddingRight: 0,
    marginLeft: isMobile ? "-6px" : "0px",
    marginRight: isMobile ? "-6px" : "0px",
  };
  const cardContent = {
    display: "flex",
    alignItems: "center",
    gap: isMobile ? "10px" : isTabScreen ? "12px" : "16px",
    padding: isMobile ? "12px" : isTabScreen ? "14px" : "18px",
    minHeight: isMobile ? "84px" : isTabScreen ? "96px" : "110px",
    background: "linear-gradient(135deg, #FFFDFB 0%, #fa86a7ff 100%)",
  };
  const cardImage = {
    width: isMobile ? "46px" : isTabScreen ? "56px" : "68px",
    height: isMobile ? "46px" : isTabScreen ? "56px" : "68px",
    borderRadius: isMobile ? "10px" : isTabScreen ? "11px" : "12px",
    objectFit: "cover",
    flexShrink: 0,
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.12)",
  };
  const testnm = {
    fontSize: isMobile ? "15px" : isTabScreen ? "17px" : "22px",
    fontWeight: "600",
    color: "#004AAD",
    lineHeight: isMobile ? "1.25" : isTabScreen ? "1.28" : "1.3",
    width: "100%",
    whiteSpace: "normal",
    wordBreak: "normal",
    overflowWrap: "break-word",
    textAlign: "left",
    letterSpacing: "0.2px",
  };
  const titleWrap = {
    flex: 1,
    minWidth: isMobile ? "0" : isTabScreen ? "0" : "120px",
    padding: isMobile ? "6px 8px" : isTabScreen ? "8px 10px" : "10px 12px",
    backgroundColor: "rgba(255, 255, 255, 0.85)",
    borderRadius: isMobile ? "10px" : isTabScreen ? "11px" : "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
  };

  const para = {
    paddingBottom: "24px",
    fontFamily: "poppins",
    fontSize: isMobile ? "13px" : "14px",
    fontWeight: "400",
    lineHeight: "1.6",
    color: "#333333",
  };
  const parahead = {
    paddingBottom: "10px",
    marginTop: "30px",
    fontFamily: "poppins",
    fontSize: isMobile ? "15px" : "16px",
    fontWeight: "600",
    color: "#333333",
  };
  const wrapper = {
    marginLeft: isMobile ? "12px" : isTabScreen ? "20px" : "50px",
    marginRight: isMobile ? "12px" : isTabScreen ? "20px" : "50px",
    paddingLeft: isMobile ? "12px" : isTabScreen ? "20px" : "28px",
    paddingRight: isMobile ? "12px" : isTabScreen ? "20px" : "28px",
    paddingBottom: "28px",
    background: "#FBFBFB",
    borderRadius: "12px",
    paddingTop: isMobile ? "18px" : "24px",
    marginBottom: "50px",
    minHeight: isMobile ? "auto" : "72vh",
    overflowY: "auto",
  };
  const cardStyle = {
    border: "none",
    borderRadius: "18px",
    overflow: "hidden",
    boxShadow: "0 8px 22px rgba(0, 0, 0, 0.08)",
    background: "transparent",
  };
  const audioStyle = {
    width: "100%",
    maxWidth: "500px",
  };

  return (
    <div style={wrapper}>
      <div>
        {testinfo === true && testdata ? (
          <>
            <div style={back} onClick={() => backtotestlist()}>
              BACK
            </div>
            <div style={heading}>{testdata.testname}</div>
            <div style={parahead}>{testdata.infohead}</div>
            <div style={para}>{testdata.info}</div>
            <audio controls style={audioStyle} key={testdata.img2}>
              <source src={testdata.img2} type="audio/mpeg" />
              Your browser does not support the audio element.
            </audio>
          </>
        ) : (
          <>
            <div
              style={back}
              onClick={() => {
                setSelected(false);
                setExpand(true);
              }}
            >
              BACK
            </div>
            <div style={heading}>Pregnancy Raga </div>
            <div
              className="container"
              style={{
                paddingLeft: isMobile ? "0px" : undefined,
                paddingRight: isMobile ? "0px" : undefined,
              }}
            >
              {isLoadingRagas ? (
                <div style={para}>Loading Pregnancy Raga audio...</div>
              ) : ragaError ? (
                <div style={para}>{ragaError}</div>
              ) : ragaList.length === 0 ? (
                <div style={para}>No Pregnancy Raga audio found.</div>
              ) : (
                <div className="row" style={innerrow}>
                  {ragaList.map((r) => (
                    <div
                      className={
                        isMobile
                          ? "col-12"
                          : isTabScreen
                            ? "col-sm-6"
                            : "col-md-4 col-lg-3"
                      }
                      style={innercol}
                      onClick={() => handletestinfo(r)}
                      key={`${r.testname}-${r.img2}`}
                    >
                      <div className="card" style={cardStyle}>
                        <div style={cardContent}>
                          <img src={r.img} style={cardImage} alt={r.testname} />
                          <div style={titleWrap}>
                            <div style={testnm}>{r?.testname}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
export default PregnancyRaga;
